import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./targetTabset.html";
import { MIGRATION_STATUS, VALIDATION_COMPLETE, VALIDATION_FAILURE, ITEMS_DEPLOYED, DEPLOY_FAILURE, TAB_TITLES } from '../utils/appConstants';
const {
  TRANSLATIONS
} = TAB_TITLES;
const {
  DUPLICATE_CONF,
  COMPLETED,
  MIGRATION_PARTIAL_SUCCESS,
  MIGRATION_FAILED,
  IMPORT_FAILED,
  VALIDATION_FAILED,
  VALIDATION_COMPLETED
} = MIGRATION_STATUS;
class TargetTabset extends LightningElement {
  constructor() {
    super();
    this.queuedTabTitle = 'Queued (0)';
    this.deployedTabTitle = 'Deployed (0)';
    this.errorTabTitle = 'Deployment Errors (0)';
    this.validatedItems = [];
    this.nonDuplicateValidatedItems = [];
    this.queuedItems = [];
    this.deployedItems = [];
    this.erroredItems = [];
    this.showQueuedView = false;
    this.showSpinner = false;
    this.disableDeploy = true;
    this.disableOverwrite = true;
    this.previousDeployedItems = [];
    this.isTargetTabsetRendered = false;
    this.updatedSelectedItems = [];
    this.disableValidate = false;
    this.translationLanguages = [];
    this.updateValidateBtnStatus = (disableValidate, disableDeploy, translationLanguages) => {
      const me = this;
      me.disableValidate = disableValidate;
      me.disableDeploy = disableDeploy;
      this.translationLanguages = translationLanguages;
    };
    this.clearQueueList = () => {
      if (this.template.querySelector('my-queued-view')) {
        this.template.querySelector('my-queued-view').handleClearList();
      }
      ;
    };
    this.clearQueuedCount = () => {
      this.queuedTabTitle = `Queued (${0})`;
      window.validationComplete = false;
    };
    this.removeTargetRecord = event => {
      const {
        detail
      } = event;
      this.updateQueuedCount(detail);
    };
    this.handleValidateAndDeployResponse = event => {
      const me = this;
      const {
        detail
      } = event;
      const {
        isValidate,
        response
      } = detail;
      if (isValidate) {
        me.handleValidate(response);
      } else {
        me.handleDeploy(response);
      }
      this.hideProgress();
    };
    this.handleValidate = response => {
      const me = this;
      const {
        validationResult,
        status,
        message
      } = response;
      let preMigrationData = [];
      let duplicatePreMigrationData = [];
      const validationCompleteStatus = [VALIDATION_COMPLETED, COMPLETED, MIGRATION_PARTIAL_SUCCESS];
      window.validationComplete = true;
      if (validationCompleteStatus.includes(status)) {
        duplicatePreMigrationData = JSON.parse(JSON.stringify(me.queuedItems));
        const details = {
          message: VALIDATION_COMPLETE
        };
        const validationComplete = new CustomEvent('migratecomplete', {
          detail: details
        });
        this.dispatchEvent(validationComplete);
        me.disableOverwrite = true;
        me.disableDeploy = false;
      } else if (status === VALIDATION_FAILED) {
        let {
          validationMessageList
        } = validationResult;
        let uniqueIds = [];
        const uniqueValidationMessageList = [];
        for (let index = 0; index < validationMessageList.length; index++) {
          const {
            id
          } = validationMessageList[index];
          if (!uniqueIds.includes(id)) {
            uniqueIds.push(id);
            uniqueValidationMessageList.push(validationMessageList[index]);
          }
        }
        uniqueIds = [];
        for (let index = 0; index < uniqueValidationMessageList.length; index++) {
          const {
            validationType
          } = uniqueValidationMessageList[index];
          if (validationType !== DUPLICATE_CONF) {
            preMigrationData.push(uniqueValidationMessageList[index]);
          } else {
            duplicatePreMigrationData.push(uniqueValidationMessageList[index]);
          }
        }
        const deltaSuccessConfList = me.queuedItems.filter(item => !uniqueValidationMessageList.some(uniqueItem => item.id === uniqueItem.id));
        if (preMigrationData.length > 0 && deltaSuccessConfList.length > 0 && duplicatePreMigrationData.length === 0) {
          if (this.template.querySelector('my-queued-view')) {
            this.template.querySelector('my-queued-view').updateQueuedViewFooterAfterValidation(true, false);
          }
          ;
        } else if (preMigrationData.length > 0 && deltaSuccessConfList.length > 0 && duplicatePreMigrationData.length > 0) {
          if (this.template.querySelector('my-queued-view')) {
            this.template.querySelector('my-queued-view').updateQueuedViewFooterAfterValidation(false, false);
          }
          ;
        } else if (preMigrationData.length > 0 && duplicatePreMigrationData.length === 0) {
          if (this.template.querySelector('my-queued-view')) {
            this.template.querySelector('my-queued-view').updateQueuedViewFooterAfterValidation(true, true);
          }
          ;
        } else if (preMigrationData.length === 0 && duplicatePreMigrationData.length > 0) {
          me.disableDeploy = preMigrationData.length === uniqueValidationMessageList.length ? true : false;
          if (this.template.querySelector('my-queued-view')) {
            this.template.querySelector('my-queued-view').updateQueuedViewFooterAfterValidation(false, me.disableDeploy);
          }
          ;
        } else if (preMigrationData.length > 0 && duplicatePreMigrationData.length > 0) {
          if (this.template.querySelector('my-queued-view')) {
            this.template.querySelector('my-queued-view').updateQueuedViewFooterAfterValidation(false, true);
          }
          ;
        }
        preMigrationData = this.getFilterOverwriteMigrationData(me.queuedItems, preMigrationData);
        duplicatePreMigrationData = this.getFilterOverwriteMigrationData(me.queuedItems, uniqueValidationMessageList);
        preMigrationData = preMigrationData.filter(element => {
          return element !== undefined;
        });
        duplicatePreMigrationData = duplicatePreMigrationData.filter(element => {
          return element !== undefined;
        });
        const details = {
          message: VALIDATION_FAILURE,
          validationMessageList: validationMessageList,
          uniqueValidationMessageList: uniqueValidationMessageList
        };
        const validationComplete = new CustomEvent('migrateerror', {
          detail: details
        });
        this.dispatchEvent(validationComplete);
      } else if (status === MIGRATION_FAILED || status === IMPORT_FAILED) {
        const details = {
          message: message,
          validationMessageList: []
        };
        const validationFailed = new CustomEvent('migrateerror', {
          detail: details
        });
        this.dispatchEvent(validationFailed);
      }
      if (preMigrationData.length > 0) {
        me.validatedItems = preMigrationData;
      } else {
        me.validatedItems = [];
      }
      if (duplicatePreMigrationData.length > 0) {
        me.nonDuplicateValidatedItems = duplicatePreMigrationData;
      } else {
        me.nonDuplicateValidatedItems = [];
      }
    };
    this.getFilterOverwriteMigrationData = (selectedRowsData, preMigrationData) => {
      let uniqueDeveloperNames = [];
      let copyOfSelectedRowsData = JSON.parse(JSON.stringify(selectedRowsData));
      for (let i = 0; i < preMigrationData.length; i++) {
        const {
          developerName,
          parentDeveloperName
        } = preMigrationData[i];
        const parDeveloperName = parentDeveloperName || developerName;
        uniqueDeveloperNames.push(parDeveloperName);
      }
      uniqueDeveloperNames = [...new Set(uniqueDeveloperNames)];
      for (let index = 0; index < copyOfSelectedRowsData.length; index++) {
        const {
          developerName
        } = copyOfSelectedRowsData[index];
        if (uniqueDeveloperNames.includes(developerName)) {
          delete copyOfSelectedRowsData[index];
        }
      }
      return copyOfSelectedRowsData;
    };
    this.handleDeploy = response => {
      const me = this;
      const {
        deployedComponents,
        failureComponents,
        status
      } = response;
      const currentDeployedItems = this.formatDeployedConfigsDateTime(deployedComponents);
      me.previousDeployedItems = [...currentDeployedItems, ...me.previousDeployedItems];
      me.deployedItems = me.previousDeployedItems;
      me.erroredItems = failureComponents;
      const deployedCount = me.deployedItems.length;
      const failureCount = failureComponents.length;
      me.deployedTabTitle = `Deployed (${deployedCount})`;
      me.errorTabTitle = `Deployment Errors (${failureCount})`;
      me.updateQueuedItems(deployedComponents);
      let deployStatus;
      if (failureCount > 0) {
        const details = {
          message: DEPLOY_FAILURE,
          validationMessageList: failureComponents
        };
        deployStatus = new CustomEvent('migrateerror', {
          detail: details
        });
      } else {
        me.updatedSelectedItems = [];
        const details = {
          message: currentDeployedItems.length + ITEMS_DEPLOYED,
          status: status
        };
        deployStatus = new CustomEvent('migratecomplete', {
          detail: details
        });
      }
      this.dispatchEvent(deployStatus);
      if (this.template.querySelector('my-queued-view')) {
        this.template.querySelector('my-queued-view').updateQueuedViewFooter(true, true);
        this.template.querySelector('my-queued-view').updateOverwriteValueAfterDeploy(false);
      }
      ;
    };
    this.formatDeployedConfigsDateTime = data => {
      let tempDeployedData = [];
      let langNameArray = [];
      for (let index = 0; index < data.length; index++) {
        const {
          componentType,
          developerName,
          id
        } = data[index];
        let {
          name
        } = data[index];
        if (componentType == TRANSLATIONS) {
          name = name.split('-')[0];
        }
        let {
          deployedTime
        } = data[index];
        if (deployedTime) {
          deployedTime = new Date().toLocaleString(navigator.language, {
            hour12: true
          });
        }
        const formattedData = {
          componentType,
          developerName,
          id,
          name,
          deployedTime
        };
        if (componentType === TRANSLATIONS && !langNameArray.includes(name)) {
          langNameArray.push(name);
          tempDeployedData.push(formattedData);
        }
        if (componentType !== TRANSLATIONS) {
          tempDeployedData.push(formattedData);
        }
      }
      return tempDeployedData;
    };
    this.updateQueuedData = (uniqueValidationMessageList, validationList, queuedList) => {
      const formattedErrorMessages = this.formatValidationListMessages(validationList, queuedList);
      const formattedValidationList = this.formattedValidationList(uniqueValidationMessageList, queuedList, formattedErrorMessages);
      this.validatedItems = formattedValidationList;
      this.queuedItems = formattedValidationList;
    };
    this.formattedValidationList = (validationList, queuedList, formattedErrorMessages) => {
      const deltaQueuedList = queuedList.filter(queuedItem => !validationList.some(validationItem => queuedItem.id === validationItem.id));
      const filteredQueuedList = deltaQueuedList.filter(deltaQueuedItem => !validationList.some(validationItem => deltaQueuedItem.developerName === validationItem.parentDeveloperName));
      const formattedQueuedList = this.formattedQueuedList(filteredQueuedList);
      const mergedList = [...validationList, ...formattedQueuedList];
      let formattedValidationList = [];
      for (let index = 0; index < mergedList.length; index++) {
        const {
          id,
          developerName,
          validationType,
          componentType
        } = mergedList[index];
        const isError = validationType !== 'Completed' ? true : false;
        const messages = formattedErrorMessages.get(id);
        const validationTooltipMessages = this.formatMessagesForTooltip(messages);
        const formattedName = this.formatQueuedName(id, queuedList, developerName);
        const formattedList = {
          id,
          name: formattedName,
          developerName,
          message: messages,
          validationTooltipMessages,
          validationType,
          componentType,
          isError
        };
        formattedValidationList.push(formattedList);
      }
      return formattedValidationList;
    };
    this.formattedQueuedList = deltaQueuedList => {
      let tempQueuedList = [];
      for (let index = 0; index < deltaQueuedList.length; index++) {
        const {
          id,
          name,
          developerName,
          componentType
        } = deltaQueuedList[index];
        const validationType = 'Completed';
        const message = '';
        const formattedList = {
          id,
          name,
          developerName,
          message,
          validationType,
          componentType
        };
        tempQueuedList.push(formattedList);
      }
      return tempQueuedList;
    };
    this.formatQueuedName = (id, queuedList, validationItemDeveloperName) => {
      let formattedName;
      let queuedItem = queuedList.find(item => item.id === id);
      if (queuedItem) {
        formattedName = queuedItem.name;
      } else {
        const queuedDeveloperNameItem = queuedList.find(item => item.developerName === validationItemDeveloperName);
        if (queuedDeveloperNameItem) {
          formattedName = queuedDeveloperNameItem.name;
        }
      }
      return formattedName;
    };
    this.formatValidationListMessages = (validationList, queuedList) => {
      const messagesMap = new Map();
      for (let index = 0; index < queuedList.length; index++) {
        const {
          id,
          developerName
        } = queuedList[index];
        let validationItems = validationList.filter(item => item.id === id);
        let isParentDeveloperNameExists = false;
        if (validationItems && validationItems.length === 0) {
          isParentDeveloperNameExists = true;
          validationItems = validationList.filter(item => item.parentDeveloperName === developerName);
        }
        let messages = [];
        if (validationItems && validationItems.length > 0) {
          let mapId = id;
          let validationItemId;
          for (let msgIndex = 0; msgIndex < validationItems.length; msgIndex++) {
            const {
              id,
              message
            } = validationItems[msgIndex];
            validationItemId = id;
            messages.push(message);
          }
          if (isParentDeveloperNameExists) {
            mapId = validationItemId;
          }
          messagesMap.set(mapId, messages.join(';'));
        }
      }
      return messagesMap;
    };
    this.formatMessagesForTooltip = messages => {
      let formattedMessages;
      if (messages) {
        let formatMessageArray = [];
        let messagesArray = messages.split(';');
        let count = 1;
        for (let index = 0; index < messagesArray.length; index++) {
          if (messagesArray.length > 1) {
            formatMessageArray.push(`${count}. ${messagesArray[index]} `);
          } else {
            formatMessageArray.push(`${messagesArray[index]} `);
          }
          count += 1;
        }
        const strArray = formatMessageArray.toString();
        formattedMessages = this.replaceCommaWithNewLine(strArray);
      }
      return formattedMessages;
    };
    this.replaceCommaWithNewLine = strArray => {
      let dataToArray;
      if (strArray) {
        dataToArray = strArray.split(',').map(item => item.trim());
        dataToArray = dataToArray.join('\n');
      }
      return dataToArray;
    };
    this.updateQueuedItems = deployedComponents => {
      const me = this;
      const formattedQueuedItems = this.formattedUpdatedQueuedItems(this.queuedItems);
      const tempDeployedComponents = this.formatTranslationsDeployedComponents(deployedComponents);
      deployedComponents = tempDeployedComponents.length > 0 ? tempDeployedComponents : deployedComponents;
      const updatedQueuedList = formattedQueuedItems.filter(o1 => !deployedComponents.some(o2 => o1.id === o2.id));
      const count = updatedQueuedList ? updatedQueuedList.length : 0;
      me.queuedTabTitle = `Queued (${count})`;
      me.queuedItems = updatedQueuedList;
      const updateSourceTableRows = new CustomEvent('updatesourcetablerows', {
        detail: updatedQueuedList,
        bubbles: true,
        composed: true
      });
      this.dispatchEvent(updateSourceTableRows);
    };
    this.formatTranslationsDeployedComponents = data => {
      let langArray = [];
      let tempTranslations = [];
      for (let index = 0; index < data.length; index++) {
        const {
          componentType
        } = data[index];
        let {
          name
        } = data[index];
        if (componentType == TRANSLATIONS) {
          name = name.split('-')[0];
          if (!langArray.includes(name)) {
            langArray.push(name);
          }
        }
      }
      for (let index = 0; index < langArray.length; index++) {
        const formatRow = {
          name: langArray[index],
          id: this.translationLanguages.findIndex(element => element === langArray[index]) + 1,
          data: data
        };
        tempTranslations.push(formatRow);
      }
      return tempTranslations;
    };
    this.hideProgress = () => {
      const hideProgressbar = new CustomEvent('hidevalidatedeployprogressbar', {
        bubbles: true,
        composed: true
      });
      this.dispatchEvent(hideProgressbar);
    };
    this.formattedUpdatedQueuedItems = queuedItems => {
      let tempQueuedItems = [];
      for (let index = 0; index < queuedItems.length; index++) {
        const {
          id,
          name,
          developerName,
          componentType,
          isError,
          validationType,
          message,
          translationConfigurations
        } = queuedItems[index];
        const formattedQueuedItem = {
          id,
          name,
          developerName,
          componentType,
          isError,
          validationType,
          message,
          translationConfigurations
        };
        tempQueuedItems.push(formattedQueuedItem);
      }
      return tempQueuedItems;
    };
    this.updateQueuedItemsForValidationSuccess = data => {
      let successValidationItems = [];
      for (let index = 0; index < data.length; index++) {
        const {
          id,
          name,
          developerName,
          message,
          validationType,
          componentType,
          translationConfigurations
        } = data[index];
        const isError = false;
        const formattedList = {
          id,
          name,
          developerName,
          message,
          validationType,
          componentType,
          isError,
          translationConfigurations
        };
        successValidationItems.push(formattedList);
      }
      this.validatedItems = successValidationItems;
      this.queuedItems = successValidationItems;
    };
    this.updateImportFileValue = (isImportFileEnabled, importFileUniqueID) => {
      if (this.template.querySelector('my-queued-view')) {
        this.template.querySelector('my-queued-view').updateImportFileValue(isImportFileEnabled, importFileUniqueID);
      }
    };
    document.addEventListener('validateanddeploy', this.handleValidateAndDeployResponse.bind(this));
    this.addEventListener('updatequeuedcount', this.removeTargetRecord.bind(this));
  }
  renderedCallback() {
    if (!this.isTargetTabsetRendered) {
      this.isTargetTabsetRendered = true;
      const updateTargetTableEvent = new CustomEvent('updatetargettable', {
        bubbles: true,
        composed: true
      });
      this.dispatchEvent(updateTargetTableEvent);
    }
  }
  updateQueuedCount(details, isTranslationSel) {
    const me = this;
    me.queuedItems = details ? details : [];
    const count = details ? details.length : 0;
    me.queuedTabTitle = `Queued (${count})`;
    this.showQueuedView = count === 0 ? false : true;
    me.disableOverwrite = true;
    if (details && details.length > 0) {
      isTranslationSel = details[0].isTranslation;
    }
    me.disableDeploy = isTranslationSel ? false : true;
    window.validationComplete = false;
    if (isTranslationSel) {
      if (this.template.querySelector('my-queued-view')) {
        this.template.querySelector('my-queued-view').updateQueuedViewFooter(false, true);
      }
      ;
    }
  }
  updateDeployedCount(count) {
    const me = this;
    me.deployedTabTitle = `Deployed (${count})`;
  }
  updateErrorsCount(count) {
    const me = this;
    me.errorTabTitle = `Deployment Errors (${count})`;
  }
}
_registerDecorators(TargetTabset, {
  publicProps: {
    updateValidateBtnStatus: {
      config: 0
    },
    clearQueueList: {
      config: 0
    },
    updateQueuedData: {
      config: 0
    },
    updateQueuedItemsForValidationSuccess: {
      config: 0
    },
    updateImportFileValue: {
      config: 0
    }
  },
  publicMethods: ["updateQueuedCount", "updateDeployedCount", "updateErrorsCount"],
  track: {
    queuedItems: 1
  },
  fields: ["queuedTabTitle", "deployedTabTitle", "errorTabTitle", "validatedItems", "nonDuplicateValidatedItems", "deployedItems", "erroredItems", "showQueuedView", "showSpinner", "disableDeploy", "disableOverwrite", "previousDeployedItems", "isTargetTabsetRendered", "updatedSelectedItems", "disableValidate", "translationLanguages", "clearQueuedCount", "removeTargetRecord", "handleValidateAndDeployResponse", "handleValidate", "getFilterOverwriteMigrationData", "handleDeploy", "formatDeployedConfigsDateTime", "formattedValidationList", "formattedQueuedList", "formatQueuedName", "formatValidationListMessages", "formatMessagesForTooltip", "replaceCommaWithNewLine", "updateQueuedItems", "formatTranslationsDeployedComponents", "hideProgress", "formattedUpdatedQueuedItems"]
});
export default _registerComponent(TargetTabset, {
  tmpl: _tmpl
});